import ListingDetail from "components/TripCard/ListingDetail";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { detailTripId, getIdiTrip, updateIdTrip } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";
import Loader from "react-loader-spinner";

const PageDetail = () => {
    let dispatch = useDispatch();
    const { listing, } = useSelector((state: RootStore) => state);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get("q");
    const trip = new URLSearchParams(search).get("t");
    // let id = 0;
    
    useEffect(() => {
        if (trip) {
            updateIdTrip(false)
        }else{
            dispatch(detailTripId(id));
        }
        // id = getIdiTrip();

    }, [])
    
    return (<div className="nc-PageHome relative overflow-hidden">
        <div className="md:py-12">
            {getIdiTrip() ? (
               <div className="flex justify-center align-middle" style={{height:'50%'}}>
                   <Loader
                        type="Circles"
                        color="rgb(210, 77, 41)"
                        height={25}
                        width={25}
                    />
                </div>
            ) :
            trip ? (
                <ListingDetail id={trip} />
            ):
            <ListingDetail id={listing.listingTripId} />
            }
        </div>
    </div>);
}

export default PageDetail;